"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_CALLBACK_DELAY = void 0;
const DEFAULT_CALLBACK_DELAY = exports.DEFAULT_CALLBACK_DELAY = 0;